import global from '../../../gui/services/global';

export function initJerseyThumbColorMap$() {
  // @ts-ignore
  return Cx.Core.Config.read$({ Id: global._JERSEY_THUMB_CONFIG_DATA_ID_ });
}